import React from 'react';
import { useMasterMedicines } from '../../../apis/master-medicines/hooks/useMasterMedicines';
import { useTablePagination } from '../../../hooks/useTablePagination';
import MasterMedicinesTable from '../components/MasterMedicinesTable';
import { LIMIT_OPTIONS } from '../../Services/constants';

const MasterMedicinesTableContainer = () => {
  const { rowsPerPage, page, handlePageChange, handleRowsPerPageChange } = useTablePagination();
  const { masterMedicines, total, isLoading } = useMasterMedicines(page, rowsPerPage);

  return (
    <MasterMedicinesTable
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={LIMIT_OPTIONS}
      onRowsPerPageChange={handleRowsPerPageChange}
      onPageChange={handlePageChange}
      total={total}
      masterMedicines={masterMedicines}
      isLoading={isLoading}
    />
  );
};

export default MasterMedicinesTableContainer;
